import React from "react";
import { CANVAS_TOOL } from "../constants";
import FigureCanvas from "./FigureCanvas";
import LineCanvas from "./LineCanvas";
import TextCanvas from "./TextCanvas";

const penList = [CANVAS_TOOL.pen, CANVAS_TOOL.eraser];

export default function AllLineCanvas({
    t, selected, tempTextRef, drawId, currentTool, canvasStyle, uuid, line, isWhiteBoard, canvasX, canvasY, scale, 
    setLine, handlerDeleteLine, handlerSelectedLine
}) {
    return (
        <>
            { line && 
                <>
                    { penList.indexOf(line.canvasTool.tool) !== -1 && 
                        <LineCanvas uuid={uuid} line={line} 
                            canvasStyle={canvasStyle} 
                            handlerDeleteLine={handlerDeleteLine}
                        /> 
                    }
                    { line.canvasTool.tool === CANVAS_TOOL.text && 
                        <TextCanvas tempTextRef={tempTextRef} 
                            t={t} 
                            selected={selected}
                            uuid={uuid} line={line}
                            drawId={drawId}
                            currentTool={currentTool} 
                            canvasStyle={canvasStyle}
                            isWhiteBoard={isWhiteBoard}
                            scale={scale}
                            canvasX={canvasX}
                            canvasY={canvasY}
                            setLine={setLine}
                            handlerSelectedLine={handlerSelectedLine}
                            handlerDeleteLine={handlerDeleteLine}
                        />
                    }
                    { line.canvasTool.tool === CANVAS_TOOL.figure &&
                        <FigureCanvas
                            selected={selected}
                            drawId={drawId}
                            uuid={uuid} line={line}
                            currentTool={currentTool} 
                            canvasStyle={canvasStyle}
                            isWhiteBoard={isWhiteBoard}
                            scale={scale}
                            canvasX={canvasX}
                            canvasY={canvasY}
                            setLine={setLine}
                            handlerSelectedLine={handlerSelectedLine}
                            handlerDeleteLine={handlerDeleteLine}
                        />
                    }
                </>
            }
        </>
    )
}